import Vue from 'vue'
import App from './App'
// vue-router
import router from './router'
import './router/auth'
// Vuex
import Vuex from 'vuex'
import store from './store'
// ElementUI & normalize
import 'normalize.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'
// Lodash
import lodash from 'lodash'
// 'date-fns'
// FontAwesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

// HighCharts
import HighchartsVue from 'highcharts-vue'

// 加入動畫效果：SequentialEntrance
import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'

// import component and stylesheet
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
// 在組件中可以使用 fragment tag 避免多產生一層 div wrapper
import { Plugin } from 'vue-fragment'

Vue.use(Plugin)

library.add(fas, far, fab)
dom.watch()
Vue.use(SequentialEntrance)
// see docs for available options
const datepickerOptions = {
  dateLabelFormat: ' YYYY, dddd, MMMM D',
  sundayFirst: true,
  days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  daysShort: ['一', '二', '三', '四', '五', '六', '日'],
  monthNames: [ '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月' ],
  colors: {
    selected: '#4da1ff',
    inRange: '#83beff',
    selectedText: '#fff',
    text: '#4a4a4a',
    inRangeBorder: '#4da1ff',
    disabled: '#fff',
    hoveredInRange: '#83beff'
  },
  texts: {
    apply: '確定',
    cancel: '取消',
    keyboardShortcuts: 'Keyboard'
  }
}
// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

Vue.use(Vuex)
Vue.use(ElementUI, { locale })
Vue.use(HighchartsVue)
Vue.prototype.$lodash = lodash

Vue.config.productionTip = false
// Vue.config.devtools = true
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
